/** import external dependencies */
import $ from 'jquery/dist/jquery.js';
import 'waypoints/lib/jquery.waypoints.min';
import 'jquery-validation/dist/jquery.validate'; // import 'prcomboselect';

/** import local dependencies */

import Router from './util/Router';
import common from './routes/common';
import pageTemplateDefault from './routes/home';
import pageTemplateTemplateExhibitionDetail from './routes/exhibition-detail';
import pageTemplateTemplateExhibitionLanding from './routes/exhibition-landing';
import pageTemplateTemplateActivationKitLanding from './routes/activation-kit-landing';
import pageTemplateTemplateActivationKitDetail from './routes/activation-kit-detail';
import pageTemplateTemplateFlex from './routes/flex';
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */

var routes = new Router({
  /** All pages */
  common: common,

  /** Home page */
  pageTemplateDefault: pageTemplateDefault,
  pageTemplateTemplateExhibitionDetail: pageTemplateTemplateExhibitionDetail,
  pageTemplateTemplateExhibitionLanding: pageTemplateTemplateExhibitionLanding,
  pageTemplateTemplateActivationKitLanding: pageTemplateTemplateActivationKitLanding,
  pageTemplateTemplateActivationKitDetail: pageTemplateTemplateActivationKitDetail,
  pageTemplateTemplateFlex: pageTemplateTemplateFlex
});
/** Load Events */

jQuery(document).ready(function () {
  return routes.loadEvents();
});


// WEBPACK FOOTER //
// ./scripts/main.js